import Route from './route/ProspectRouteInitialState'

const { Record } = require('immutable')

export default Record({
    route: Route()
})